import { Text, ActionIcon, Group, useMantineColorScheme, Paper, Modal, Button } from '@mantine/core'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useDisclosure } from '@mantine/hooks'
import { TbLogout2 } from 'react-icons/tb'
import { Client } from '@/api/main/client'
import { useMutation } from '@tanstack/react-query'
import { notifications } from '@mantine/notifications'
import { Driver } from '@/api/navigationApi/types.gen'
import { driverSignOutMutation } from '@/api/navigationApi'

const SignedInDriverBox: FC<{
  driver?: Driver
  client: Client | undefined
}> = ({ driver, client }) => {
  const { colorScheme } = useMantineColorScheme()
  const { t } = useTranslation(['navigation', 'buttons'])
  const [logoutModalOpened, { open: openLogoutModal, close: closeLogoutModal }] = useDisclosure(false)

  const { mutate: signOut, status } = useMutation({
    ...driverSignOutMutation({ client }),
    onSuccess: () => {
      notifications.show({ message: t('signedOutSuccessfully'), color: 'green' })
      closeLogoutModal()
    },
    onError: () => {
      notifications.show({ message: t('failedToSignOut'), color: 'red' })
      closeLogoutModal()
    },
  })

  if (!driver) {
    return null
  }

  return (
    <>
      <Modal opened={logoutModalOpened} onClose={closeLogoutModal} title={t('confirmSignOut')} centered zIndex={10000}>
        <Text size="sm" mb="lg">
          {t('confirmSignOutMessage')}
        </Text>
        <Group justify="flex-end">
          <Button variant="default" onClick={closeLogoutModal}>
            {t('cancel', { ns: 'buttons' })}
          </Button>
          <Button color="red" loading={status === 'pending'} onClick={() => signOut({})}>
            {t('signOut')}
          </Button>
        </Group>
      </Modal>

      <Paper
        p={0}
        withBorder
        shadow="xs"
        style={{
          border: '1px solid var(--mantine-color-gray-3)',
          overflow: 'hidden',
          cursor: 'pointer',
        }}
        onClick={openLogoutModal}
      >
        <Group gap="xs" p="md">
          <Text size="xl" fw={500} c={colorScheme === 'dark' ? 'white' : 'black'}>
            {driver.name}
          </Text>
          <ActionIcon
            loading={status === 'pending'}
            size={30}
            color="red"
            variant="transparent"
            style={{ pointerEvents: 'none' }}
          >
            <TbLogout2 size={24} />
          </ActionIcon>
        </Group>
      </Paper>
    </>
  )
}

export default SignedInDriverBox
